const storage = {
    cookie: {
      set: (name, value, day) => {
        if (day !== 0) {
          // 当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
          const expires = day * 24 * 60 * 60 * 1000;
          const date = new Date(+new Date() + expires);
          window.document.cookie = name + '=' + escape(value) + ';Path=/;expires=' + date.toUTCString();
        } else {
          window.document.cookie = name + '=' + escape(value);
        }
      },
      get: (name) => {
        const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        const arr = window.document.cookie.match(reg);
        if (arr) return unescape(arr[2]);
        return null;
      },
      del: (name) => {
        storage.cookie.set(name, ' ', -1);
      },
      clear: () => {
        const keyArr = document.cookie.match(/[^ =;]+(?=\=)/g);
        keyArr.forEach(key => storage.cookie.del(key));
      },
    },
    session: {
      set: (key, value) => {
        window.sessionStorage.setItem(key, value);
      },
      get: key => window.sessionStorage.getItem(key),
      del: key => window.sessionStorage.removeItem(key),
      clear: () => {
        for (let i = window.sessionStorage.length - 1; i >= 0; i -= 1) {
          storage.session.del(window.sessionStorage.key(i));
        }
      },
    },
    local: {
      set: (key, value) => {
        window.localStorage.setItem(key, value);
      },
      get: key => window.localStorage.getItem(key),
      del: key => window.localStorage.removeItem(key),
      clear: () => {
        for (let i = window.sessionStorage.length - 1; i >= 0; i -= 1) {
          storage.local.del(window.localStorage.key(i));
        }
      },
    },
  };
  
  export default storage;
  